/*eslint-disable */

export function getAllOrders(state) {
    return state.allSorted || [];
}

export function getCompletedOrders(state) {
    return state.completedSorted || [];
}

export function getCurrentOrders(state) {
    return state.currentSorted || [];
}

export function getBackOrders(state) {
    return state.backSorted || [];
}

export function getSearchIndexById(state) {
    return state.searchIndexById || {};
}

export function getToken(state) {
    return state.token;
}

export function getTokens(state) {
    return state.tokens;
}

export function getSearchFilterObj(state) {
    return state.searchFilterObj;
}

export function getFilter(state) {
    return state.filter;
}

export function getPerPage(state) {
    return state.perPage;
}

export function getCurrentPageCurrent(state) {
    return state.currentPageCurrent;
}

export function getCurrentPageCompleted(state) {
    return state.currentPageCompleted;
}

export function getCurrentPageBackOrder(state) {
    return state.currentPageBackOrder;
}

export function getIsNeedUpdate(state) {
    return state.isNeedUpdate;
}

export function getCurrentOrderId(state) {
    return state.currentOrderId;
}

export function ordersFromUpdate(state) {
    return state.ordersFromUpdate;
}
